var SuggestAListingPage;
(function (SuggestAListingPage) {
    function Init() {
        $(function () {
            $.validator.setDefaults({
                highlight: function (element) {
                    var group = $(element).closest('.form-group');
                    if (group.length) {
                        group.addClass('has-error');
                    }
                    else {
                        $(element).addClass('has-error');
                    }
                },
                unhighlight: function (element) {
                    var group = $(element).closest('.form-group');
                    if (group.length) {
                        group.removeClass('has-error');
                    }
                    else {
                        $(element).removeClass('has-error');
                    }
                },
                errorElement: 'span',
                errorClass: 'help-block',
                errorPlacement: function (error, element) {
                    var group = $(element).closest('.form-group');
                    if (group.length) {
                        error.insertAfter(group);
                    }
                    else {
                        error.insertAfter(element);
                    }
                }
            });
            $("#Services").selectize({
                delimiter: '|',
                maxItems: null,
                create: false,
                closeAfterSelect: false,
                openOnFocus: false,
                plugins: { "accessibility": { Label: "Select a Service Category", DescribedBy: "servicesDescription" } }
            });
            // Disable the Enter key from submitting the form (i.e when users press Enter to select address or add a new line in the brief description)
            $(document).on("keypress", ":input:not(textarea)", function (event) {
                return event.keyCode != 13;
            });
            $("#divFormattedAddress").hide();
            $('#Address1').prop("readonly", true);
            $('#Address2').prop("readonly", true);
            $('#Suburb').prop("readonly", true);
            $('#Postcode').prop("readonly", true);
            $('#State').prop("readonly", true);
            $("#ABN").mask('99 999 999 999');
            var q = "";
            var orgs = new Bloodhound({
                name: "organisations",
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace("DisplayName"),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: 20,
                remote: {
                    url: "/SuggestAListing/FetchOrganisations",
                    replace: function (url, query) {
                        q = query;
                        // Change the url target url so it triggers
                        url = url + "#" + encodeURIComponent(q);
                        return url;
                    },
                    ajax: {
                        beforeSend: function (ev, settings) {
                            settings.data = JSON.stringify({ Search: q });
                        },
                        dataType: "json",
                        contentType: "application/json; charset=utf-8",
                        type: "POST"
                    },
                    filter: function (results) {
                        return $.map(results, function (result) {
                            return {
                                DisplayName: result.DisplayName,
                                OrganisationID: result.OrganisationID
                            };
                        });
                    }
                }
            });
            orgs.initialize();
            $("#OrganisationName").typeahead({
                hint: true,
                minLength: 3,
                highlight: true
            }, {
                name: "organisations",
                displayKey: "DisplayName",
                source: orgs.ttAdapter(),
                templates: {
                    suggestion: function (d) {
                        return "<p class='needsclick'>" + d.DisplayName + "</p>";
                    }
                }
            });
            $("#OrganisationName").on("typeahead:selected", function (obj, datum) {
                $("#LocationName").val("");
                $(".outletPreview").html("");
                $("#LocationName").removeClass("sal-square-right");
                $("#divContactDetails").show();
                $("#divLocationAddress").show();
                $("#OutletID").val("0");
                $("#OrganisationID").val(datum.OrganisationID);
            });
            $("#btnSave").on("click", function (e) {
                e.preventDefault();
                if ($("#suggestAListingForm").valid()) {
                    $("#suggestAListingForm").submit();
                }
                else {
                    $(".has-error :input:not([readonly])").first().focus();
                }
            });
            $("#suggestAListingForm").validate({
                rules: {
                    LocationPhone: {
                        ausPhone: true,
                        require_from_group: [1, ".location-contact"]
                    },
                    LocationEmail: {
                        mcdEmail: true,
                        require_from_group: [1, ".location-contact"]
                    },
                    LocationWebsite: {
                        url: true,
                        require_from_group: [1, ".location-contact"]
                    },
                    UserPhone: {
                        ausPhone: true,
                        require_from_group: [1, ".user-contact"]
                    },
                    UserMobile: {
                        ausMobile: true,
                        require_from_group: [1, ".user-contact"]
                    },
                    UserEmail: {
                        mcdEmail: true,
                        require_from_group: [1, ".user-contact"]
                    },
                    ContactPhone: {
                        ausPhone: true
                    },
                    ContactMobile: {
                        ausMobile: true
                    },
                    ContactEmail: {
                        mcdEmail: true
                    },
                    AddressComplete: {
                        require_from_group: [4, ".location-address"]
                    },
                    Suburb: {
                        require_from_group: [4, ".location-address"]
                    },
                    State: {
                        require_from_group: [4, ".location-address"]
                    },
                    Postcode: {
                        require_from_group: [4, ".location-address"]
                    }
                },
                messages: {
                    OrganisationName: "An Organisation Name is required",
                    LocationPhone: { require_from_group: "A Phone, Email or Website is required", ausPhone: "Please enter a valid Phone number" },
                    LocationEmail: { require_from_group: "A Phone, Email or Website is required", mcdEmail: "Please enter a valid Email address" },
                    LocationWebsite: { require_from_group: "A Phone, Email or Website is required", url: "Please enter a valid Website" },
                    AddressComplete: "An Address is required",
                    Suburb: "A Suburb is required",
                    State: "A State is required",
                    Postcode: "A Postcode is required",
                    UserPhone: { require_from_group: "A Phone, Mobile or Email is required", ausPhone: "Please enter a valid Phone number" },
                    UserMobile: { require_from_group: "A Phone, Mobile or Email is required", ausMobile: "Please enter a valid Mobile number" },
                    UserEmail: { require_from_group: "A Phone, Mobile or Email is required", mcdEmail: "Please enter a valid Email address" },
                    ContactPhone: { ausPhone: "Please enter a valid Phone number" },
                    ContactMobile: { ausMobile: "Please enter a valid Mobile number" },
                    ContactEmail: { mcdEmail: "Please enter a valid Email address" }
                }
            });
            InitAddress();
            $("#AddressComplete").on("blur", function () {
                if (!$(this).val()) {
                    $("#divFormattedAddress").hide();
                    $("#BuildingAddress").val('');
                    $("#Address1").val('');
                    $("#Address2").val('');
                    $("#Suburb").val('');
                    $("#State").val('');
                    $("#Postcode").val('');
                }
            });
            $(".ausPhone").on("blur", function () {
                if ($(this).val()) {
                    // format the number
                    Common.FormatAsAusPhone($(this), $("#State").val());
                }
            });
        });
    }
    SuggestAListingPage.Init = Init;
    var geocoder;
    var map;
    var marker;
    var autocomplete;
    var selectedLatLng;
    var selectedContent = '';
    var mapLoading = false;
    function mapsAvailable(member) {
        var maps = window.google && window.google.maps;
        return !!(maps && maps[member]);
    }
    function showMapError(message) {
        $("#sal-map-error").text(message).show();
    }
    function InitAddress() {
        // Address search works before any map exists. The map is created only when the visitor asks for it.
        var input = document.getElementById('AddressComplete');
        if (input && mapsAvailable('places') && mapsAvailable('Geocoder')) {
            geocoder = new google.maps.Geocoder();
            autocomplete = new google.maps.places.Autocomplete(input, { componentRestrictions: { country: 'au' } });
            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                clearMap();
                var place = autocomplete.getPlace();
                // Editing a confirmed selection raises place_changed with an empty place; the stale coordinates are already cleared.
                if (!place || !place.geometry || !place.geometry.location)
                    return;
                showGeocodeResults(place, 'AutoComplete failed.', '');
            });
        }
        else {
            showMapError('Address search is unavailable. Please reload the page to try again.');
        }
        $("#show-sal-map").on("click", showMap);
    }
    SuggestAListingPage.InitAddress = InitAddress;
    function showMap() {
        var button = $("#show-sal-map");
        if (mapLoading || map)
            return;
        mapLoading = true;
        button.prop("disabled", true);
        $("#sal-map-error").hide();
        try {
            if (!mapsAvailable('Map'))
                throw new Error("Maps unavailable");
            // The container must be visible before the map measures itself.
            $("#sal-map-region").show();
            map = new google.maps.Map(document.getElementById('map'), {
                center: new google.maps.LatLng(-25.049072, 134.35711879999997),
                zoom: 4,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            if (autocomplete)
                autocomplete.bindTo("bounds", map);
            google.maps.event.addListener(map, 'click', function (event) { geocodeLatLng(event.latLng); });
            if (selectedLatLng)
                markMap(selectedLatLng, selectedContent);
            button.attr("aria-expanded", "true");
            $("#sal-map-placeholder").hide();
            $("#sal-map-region").trigger("focus");
        }
        catch (error) {
            map = null;
            $("#sal-map-region").hide();
            showMapError("The map could not be loaded. Please try again.");
        }
        finally {
            mapLoading = false;
            button.prop("disabled", !!map);
        }
    }
    function setAddressEdit(readonly) {
        $("#divFormattedAddress").show();
        $('#Address1').prop("readonly", readonly);
        $('#Address2').prop("readonly", readonly);
        $('#Suburb').prop("readonly", readonly);
        $('#Postcode').prop("readonly", readonly);
        $('#State').prop("readonly", readonly);
    }
    function geocodeLatLng(latlng) {
        if (!geocoder)
            return;
        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK && results && results.length) {
                showGeocodeResults(results[0], status, '');
            }
            else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
    function showGeocodeResults(place, status, address) {
        var addr = address;
        if (place.address_components) {
            if ((place.formatted_address || "").length > 0) {
                addr = place.formatted_address;
            }
            else {
                addr = [(place.address_components[0] && place.address_components[0].short_name || ''),
                    (place.address_components[1] && place.address_components[1].short_name || ''),
                    (place.address_components[2] && place.address_components[2].short_name || '')].join(', ');
            }
            loadDetails(place);
            $('#editAddress').show();
        }
        setLocation(place.geometry.location, addr);
    }
    function loadDetails(place) {
        var su = '';
        var a1a = '';
        var a1b = '';
        var a1 = '';
        var a2 = '';
        var st = '';
        var pc = '';
        for (var i = 0; i < place.address_components.length; i++) {
            switch (place.address_components[i].types[0]) {
                case "street_address":
                    a1 = place.address_components[i].long_name;
                    break;
                case "street_number":
                    a1a = place.address_components[i].long_name;
                    break;
                case "route":
                    a1b = place.address_components[i].long_name;
                    break;
                case "locality":
                    su = place.address_components[i].long_name;
                    break;
                case "administrative_area_level_1":
                    st = place.address_components[i].short_name;
                    break;
                case "postal_code":
                    pc = place.address_components[i].short_name;
                    break;
                default: break;
            }
        }
        if (a1.length == 0)
            a1 = a1a + ' ' + a1b;
        if (a1.length > 0 || su.length > 0) {
            $("#AddressComplete").val(place.formatted_address);
            $("#BuildingAddress").val("");
            $("#Address1").val($.trim(a1) || "");
            $("#Address2").val($.trim(a2) || "");
            $("#Suburb").val($.trim(su) || "");
            $("#State").val($.trim(st) || "");
            $("#Postcode").val($.trim(pc) || "");
            setAddressEdit(true);
        }
        saveLatLng(place.geometry.location);
    }
    function saveLatLng(latlng) {
        $("#Lat").val(latlng.lat());
        $("#Lng").val(latlng.lng());
    }
    // Remembers the chosen location so a map opened later shows the pin.
    function setLocation(latlng, content) {
        selectedLatLng = latlng;
        selectedContent = content;
        saveLatLng(latlng);
        if (map)
            markMap(latlng, content);
    }
    function clearMap() {
        selectedLatLng = null;
        selectedContent = '';
        $("#Lat").val(0);
        $("#Lng").val(0);
        removeMarker();
    }
    function removeMarker() {
        if (marker == null)
            return;
        if (marker.setMap)
            marker.setMap(null);
        else
            marker.remove();
        marker = null;
    }
    // A plain pin with no label. On Mapbox the SDK's own default marker is used
    // rather than the compatibility shim's styled pin.
    function markMap(latlng, content) {
        removeMarker();
        var gl = window.mapboxgl;
        if (gl && map.native) {
            marker = new gl.Marker().setLngLat([latlng.lng(), latlng.lat()]).addTo(map.native);
        }
        else {
            marker = new google.maps.Marker({ position: latlng, map: map, clickable: false, title: content });
        }
        google.maps.event.trigger(map, 'resize');
        map.setCenter(latlng);
        saveLatLng(latlng);
        map.setZoom(15);
    }
})(SuggestAListingPage || (SuggestAListingPage = {}));
